import React, { useCallback, useMemo } from "react";
import { Button, Flex, Space, Typography } from "antd";
import type { MenuProps } from "antd";
import { loadDevicePrefs, saveDevicePrefs } from "../../zoom/devicePrefs";
import { ZoomInOutlined, ZoomOutOutlined, RedoOutlined, DragOutlined } from "@ant-design/icons";

function clamp(n: number, min: number, max: number) {
  return Math.max(min, Math.min(max, n));
}

const { Text } = Typography

export default function RemoteViewControl() {
  const prefs = useMemo(() => loadDevicePrefs(), []);
  const fit = prefs.remoteFitMode ?? "contain";
  const zoom = prefs.remoteZoom ?? 1;

  const setFit = useCallback((next: "contain" | "cover") => {
    saveDevicePrefs({ remoteFitMode: next, remotePanX: 0, remotePanY: 0 });
  }, []);

  const zoomIn = useCallback(() => {
    saveDevicePrefs({ remoteZoom: clamp((loadDevicePrefs().remoteZoom ?? 1) + 0.25, 1, 3) });
  }, []);

  const zoomOut = useCallback(() => {
    saveDevicePrefs({ remoteZoom: clamp((loadDevicePrefs().remoteZoom ?? 1) - 0.25, 1, 3), remotePanX: 0, remotePanY: 0 });
  }, []);

  const reset = useCallback(() => {
    saveDevicePrefs({ remoteFitMode: "contain", remoteZoom: 1, remotePanX: 0, remotePanY: 0 });
  }, []);

  return (
    <div style={{flexDirection: "column"}}>
      <Flex justify="flex-start" align="flex-start">
        <Space>
          <Button ghost onClick={zoomIn} variant="outlined" size="middle" title="ZoomIn" icon={<ZoomInOutlined />}>
            Zoom In
          </Button>
          <Button ghost onClick={zoomOut} variant="outlined" size="middle" title="ZoomOut" icon={<ZoomOutOutlined/>}>
            Zoom Out 
          </Button>
          <Button ghost onClick={reset} variant="outlined" size="middle" title="ZoomOut" icon={<RedoOutlined/>}>
            Reset
          </Button>
        </Space>
      </Flex>
      <Flex justify="flex-start" align="center">
        <DragOutlined style={{color: "#fff", fontSize: 20, paddingRight: 5}}/>
        <p style={{color: "#fff", fontSize: 12}}>Click and drag to position the image</p>
      </Flex>
    </div>
  );
}
